export default "__VITE_ASSET__DJcv1Bz0__"